import { GET_SERVICECITY_FAILED, GET_SERVICECITY_REQUESTED, GET_SERVICECITY_SUCCESS, GET_SERVICEREGION_FAILED, GET_SERVICEREGION_REQUESTED, GET_SERVICEREGION_SUCCESS, GET_ADDSERVICEREGION_FAILED, GET_ADDSERVICEREGION_REQUESTED, GET_ADDSERVICEREGION_SUCCESS, GET_SUBVENDORREGION_SUCCESS, GET_SUBVENDORREGION_FAILED, GET_SUBVENDORREGION_REQUESTED, GET_ADDSUBVENDORREGION_FAILED, GET_ADDSUBVENDORREGION_REQUESTED, GET_ADDSUBVENDORREGION_SUCCESS } from "resources/actionTypes";

const initialStateCity = {
  userServiceCity: [],
  loading: false,
  error: null,
};

const initialStateRegion = {
  userServiceRegion: [],
  loading: false,
  error: null,
};

const initialStateAddRegion = {
  userAddServiceRegion: [],
  loading: false,
  error: null,
}

const initialStateSubVendorRegion = {
  userSubVendorRegion: [],
  loading: false,
  error: null,
};

const initialStateAddSubVendorRegion = {
  userServiceAddSubVednorRegion: [],
  loading: false,
  error: null,
};

export function userServiceCity(state = initialStateCity, action){
  switch(action.type){
    case GET_SERVICECITY_REQUESTED:
      return{
        ...state,
        loading:true
      };
    case GET_SERVICECITY_SUCCESS:
      return{
        ...state,
        loading: false,
        userServiceCity: action.userServiceCity
      };
    case GET_SERVICECITY_FAILED:
      return{
        ...state,
        loading:false,
        error: action.message
      };
      default:
        return state;
  }
}

export function userServiceRegion(state = initialStateRegion, action){
  switch(action.type){
    case GET_SERVICEREGION_REQUESTED:
      return{
        ...state,
        loading:true
      };
    case GET_SERVICEREGION_SUCCESS:
      return{
        ...state,
        loading: false,
        userServiceRegion: action.userServiceRegion
      };
    case GET_SERVICEREGION_FAILED:
      return{
        ...state,
        loading:false,
        error: action.message
      };
      default:
        return state;
  }
}

export function userAddServiceRegion(state = initialStateAddRegion, action){
  switch(action.type){
    case GET_ADDSERVICEREGION_REQUESTED:
      return{
        ...state,
        loading:true
      };
    case GET_ADDSERVICEREGION_SUCCESS:
      return{
        ...state,
        loading: false,
        userAddServiceRegion: action.userAddServiceRegion
      };
    case GET_ADDSERVICEREGION_FAILED:
      return{
        ...state,
        loading:false,
        error: action.message
      };
      default:
        return state;
  }
}

export function userSubVendorRegion(state = initialStateSubVendorRegion, action){
  switch(action.type){
    case GET_SUBVENDORREGION_REQUESTED:
      return{
        ...state,
        loading:true
      };
    case GET_SUBVENDORREGION_SUCCESS:
      return{
        ...state,
        loading: false,
        userSubVendorRegion: action.userSubVendorRegion
      };
    case GET_SUBVENDORREGION_FAILED:
      return{
        ...state,
        loading:false,
        error: action.message
      };
      default:
        return state;
  }
}

export function userServiceAddSubVendorRegion(state = initialStateAddSubVendorRegion, action){
  switch(action.type){
    case GET_ADDSUBVENDORREGION_REQUESTED:
      return{
        ...state,
        loading:true
      };
    case GET_ADDSUBVENDORREGION_SUCCESS:
      return{
        ...state,
        loading: false,
        userAddSubVendorRegion: action.userAddSubVendorRegion
      };
    case GET_ADDSUBVENDORREGION_FAILED:
      return{
        ...state,
        loading:false,
        error: action.message
      };
      default:
        return state;
  }
}